// test270
(270 && 0);
